/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withDLSTheme} from '../../theme/withDLSTheme';
import {PrimaryButton as CurrentPrimaryButton} from './current/PrimaryButton';
import {PrimaryButton as LegacyPrimaryButton} from './legacy/PrimaryButton';

// This is essential if a client imports the `PrimaryButton` component using
// `import {PrimaryButton} from ‘./PrimaryButton’;`
export const PrimaryButton = withDLSTheme(LegacyPrimaryButton, CurrentPrimaryButton);

export default PrimaryButton;
